export default "__VITE_ASSET__CYUAIwVW__"